export default function() {
    var url = window.document.location.href.toString();
    var u = url.split('?');
    if (typeof(u[1]) == 'string') {
        if (u[1].indexOf('#') != -1) {
            u = u[1].split('#');
            u = u[0].split('&');
        } else {
            u = u[1].split('&');
        }
        var get = {};
        for (var a = 0, b = u.length; a < b; a++) {
            var j = u[a].split('=');
            if (j[0]) {
                get[j[0]] = j[1];
            } else {
                get[j[0]] = '';
            }
        }
        return get;
    } else {
        return {};
    }
}


// WEBPACK FOOTER //
// ./src/common/js/get.js